import PropTypes from 'prop-types';
import React from 'react';

import { CommonIcons } from 'common-src/assets/Icons';
import { OncehubBookingStatuses } from 'common-src/models/PatientOncehubBooking';
import { ColorsNew } from 'common-src/styles';

import styles from './StatusItem.module.scss';

const StatusItem = ({ status }) => {
  const statusData = OncehubBookingStatuses[status];
  // Default values for Athena or other non-OnceHub statuses
  const defaultStatusData = {
    iconSrc: CommonIcons.calendarCheckIcon,
    textColor: ColorsNew.darkGreen,
    text: status || 'Unknown',
  };

  const displayData = statusData || defaultStatusData;

  return (
    <div className={[styles.container, 'gap-10'].join(' ')}>
      <img className={styles.icon} src={displayData.iconSrc} alt="scheduled-call-status-icon" />
      <span
        className={[styles.text, 'font-w-500', 'font-s-14'].join(' ')}
        style={{ color: displayData.textColor }}
      >
        {displayData.text}
      </span>
    </div>
  );
};

StatusItem.propTypes = {
  status: PropTypes.string,
};

export default StatusItem;
